export default "__VITE_ASSET__BFD0FOqA__";